import React from 'react';

const GuideMessageStatus = () => (
    <div className="GuideMessageStatus">
        <div className="modal fade" id="MsgGuideModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="MessageGuide" aria-hidden="false">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="modal-title spacer-inline" id="myModalLabel">Message Status Guide</div>
                        <button type="button" className="close" aria-label="Close" data-dismiss="modal">
                            <span aria-hidden="false">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="modal-content-body">
                            <div className="descript-container">
                                Message status page shows status of the sent messages, whether they were successfully sent or failed and provides additional information about the successful delivery or reasons for failure.
                            </div>
                            <div className="modal-content-body spacer-margin6">
                                <ul>
                                    <li>
                                        <b className="blk-clr">Date Sent</b> - date and time when message was sent
                                    </li>
                                    <li>
                                        <b className="blk-clr">Sent To:</b> - destination Direct email address. Note that the same message could have been sent to multiple TO/CC addresses, but since the status could be different for each destination address, each TO address has separate line in the message status report.
                                    </li>
                                    <li>
                                        <b className="blk-clr">Message Type</b> - if message is MDN or not an MDN
                                    </li>
                                    <li>
                                        <b className="blk-clr">Status</b> - Confirmed, Failed, Success, or Accepted
                                    </li>
                                    <li>
                                        <b className="blk-clr">Extended Status</b> - if the message was successfully delivered to the destination email server, extended status will contain IP address of the server and return code (success is indicated by the SMTP code 250).
                                    </li>
                                    <li>
                                        <b className="blk-clr">Date/Time Accepted</b> - in Direct protocol guaranteed message delivery is ensured by the use of MDNs - message disposition notifications. One such MDN must be sent by the receiving HISP once the message is received, validated and accepted for delivery to the recipient. Once our HISP receives such MDN, the date/time when it was sent is logged as the date/time accepted. This type of MDN is called MDN:processed and it is mandatory according to the Direct specification, receiving HISP must send it for each successfully received message.
                                    </li>
                                    <li>
                                        <b className="blk-clr">Date/Time Confirmed</b> - second MDN, so called MDN:dispatched may be sent by the receiving HISP - it is optional. When it is sent, it typically indicates that message was indeed delivered to the intended recipient. Note that not all HISPs send it. When our HISP receives MDN:dispatched, it is logged as date/time confirmed.
                                    </li>
                                    <li>
                                        <b className="blk-clr">Message ID</b> - unique ID assigned to the message by the sender. ID is required by email standards and by Direct protocol, it can be useful if further troubleshooting is required, otherwise it can be ignored. This is included in the download report files.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
  </div>
);


export default GuideMessageStatus;
